import { render, staticRenderFns } from "./CreateAnnotationForm.vue?vue&type=template&id=61da842a&scoped=true&"
import script from "./CreateAnnotationForm.vue?vue&type=script&lang=js&"
export * from "./CreateAnnotationForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAnnotationForm.vue?vue&type=style&index=0&id=61da842a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da842a",
  null
  
)

export default component.exports